import { PayloadAction } from '@reduxjs/toolkit'
import {
  MyOrderSliceState,
  BigOrder,
  OrderPurchasesCertificate,
  GetOneOrderResponse,
  GetOneOrderAllOrderItemsResponse
} from 'src/core/models'
import { initialState } from './state'

const reducers = {
  /* My Orders Reducers */
  setMyOrdersLoading: (state: MyOrderSliceState, action: PayloadAction<boolean>) => {
    state.myOrders.loading = action.payload
  },
  setMyOrdersResponse: (state: MyOrderSliceState, action: PayloadAction<BigOrder[]>) => {
    state.myOrders.list = action.payload
  },
  setSelectedOrders: (state: MyOrderSliceState, action: PayloadAction<BigOrder[]>) => {
    state.myOrders.selected = action.payload
  },
  setFilteredOrders: (state: MyOrderSliceState, action: PayloadAction<BigOrder[]>) => {
    state.myOrders.filtered = action.payload
  },
  setFilterOrderText: (state: MyOrderSliceState, action: PayloadAction<string>) => {
    state.myOrders.filterText = action.payload
  },
  setMyOrdersError: (state: MyOrderSliceState, action: PayloadAction<string>) => {
    state.myOrders.error = action.payload
  },
  resetMyOrdersState: (state: MyOrderSliceState) => {
    state.myOrders = initialState.myOrders
    state.getCertificates = initialState.getCertificates
    state.getOne = initialState.getOne
  },
  // Certificates Purchases Reducers
  setOrderCertificatesLoading: (state: MyOrderSliceState, action: PayloadAction<boolean>) => {
    state.getCertificates.loading = action.payload
  },
  setOrderCertificatesSuccess: (state: MyOrderSliceState, action: PayloadAction<boolean>) => {
    state.getCertificates.success = action.payload
  },
  setOrderCertificatesData: (state: MyOrderSliceState, action: PayloadAction<OrderPurchasesCertificate[]>) => {
    state.getCertificates.data = action.payload
  },
  resetOrderCertificatesState: (state: MyOrderSliceState) => {
    state.getCertificates = initialState.getCertificates
  },
  // Get One Order Reducers
  setGetOneOrderLoading: (state: MyOrderSliceState, action: PayloadAction<boolean>) => {
    state.getOne.loading = action.payload
  },
  setGetOneOrderError: (state: MyOrderSliceState, action: PayloadAction<any>) => {
    state.getOne.error = action.payload
  },
  setGetOneOrderData: (state: MyOrderSliceState, action: PayloadAction<GetOneOrderResponse>) => {
    const { order, orderItem } = action.payload
    state.getOne.order = order
    state.getOne.orderItem = orderItem
  },
  resetGetOneOrderState: (state: MyOrderSliceState) => {
    state.getOne = initialState.getOne
  },

  // Get One Order and All Order Items Reducers
  setGetAllOrderItemsLoading: (state: MyOrderSliceState, action: PayloadAction<boolean>) => {
    state.getAllOrderItems.loading = action.payload
  },
  setGetAllOrderItemsError: (state: MyOrderSliceState, action: PayloadAction<any>) => {
    state.getAllOrderItems.error = action.payload
  },
  setGetAllOrderItemsData: (state: MyOrderSliceState, action: PayloadAction<GetOneOrderAllOrderItemsResponse>) => {
    const { order, orderItems } = action.payload
    state.getAllOrderItems.order = order
    state.getAllOrderItems.orderItems = orderItems
  },
  resetGetAllOrderItemsState: (state: MyOrderSliceState) => {
    state.getAllOrderItems = initialState.getAllOrderItems
  },
}

export { reducers }
